import { render, staticRenderFns } from "./PageFamilyUserMissionRemove.vue?vue&type=template&id=970c1bcc&scoped=true&"
import script from "./PageFamilyUserMissionRemove.vue?vue&type=script&lang=js&"
export * from "./PageFamilyUserMissionRemove.vue?vue&type=script&lang=js&"
import style0 from "./PageFamilyUserMissionRemove.vue?vue&type=style&index=0&id=970c1bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970c1bcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VCol,VContainer,VRow})
